import React from 'react';

const nuggetFloat = `@keyframes nuggetFloat { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }`;

export default function Header({ user, bal, page, setPage, showAuth, logout, theme, toggle }) {
  return (
    <header style={{ position: "sticky", top: 0, zIndex: 100, background: "var(--bs-bg, #0a0a0a)", borderBottom: "1px solid var(--bs-border, #1a1a1a)" }}>
      <style>{nuggetFloat}</style>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", maxWidth: 900, margin: "0 auto", padding: "12px 16px" }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, cursor: 'pointer' }} onClick={() => setPage("home")}>
          <span style={{ fontFamily: "'Dela Gothic One', serif", fontSize: 26, color: 'var(--bs-green, #00e676)', lineHeight: 1 }}>$</span>
          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, paddingBottom: 4 }}>
              <span style={{ fontFamily: "'Dela Gothic One', serif", fontSize: 20, color: 'var(--bs-ink, #ffffff)', letterSpacing: 1 }}>PayDirt</span>
              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 9, color: 'var(--bs-green, #00e676)', fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase' }}>News</span>
            </div>
            <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: 'var(--bs-ink, #999)', letterSpacing: 2, textTransform: 'uppercase', marginTop: 3 }}>Where Truth is Measured</span>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            onClick={toggle}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            style={{
              width: 36, height: 20,
              borderRadius: 10,
              background: theme === 'dark' ? '#333' : '#C8C2B8',
              cursor: 'pointer',
              position: 'relative',
              transition: 'background 0.2s ease',
              flexShrink: 0,
            }}
          >
            <div style={{
              width: 16, height: 16,
              borderRadius: '50%',
              background: theme === 'dark' ? '#fff' : '#1A1612',
              position: 'absolute',
              top: 2,
              left: theme === 'dark' ? 18 : 2,
              transition: 'left 0.2s ease',
            }} />
          </div>

        {user ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ background: "var(--bs-surface, #111)", border: "1px solid var(--bs-border, #222)", borderRadius: 8, padding: "4px 12px", textAlign: "right" }}>
              <div style={{ fontSize: 9, color: "var(--bs-amber, #ffab00)", fontFamily: "JetBrains Mono", letterSpacing: 1 }}>{user.username.toUpperCase()}</div>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                <img src="/nug_nug.jpg" alt="" style={{ width: 24, height: 20, objectFit: "contain", animation: "nuggetFloat 3s ease-in-out infinite" }} />
                <span style={{ fontSize: 16, fontFamily: "JetBrains Mono", fontWeight: 700, color: "var(--bs-amber, #ffab00)" }}>{Math.floor(bal)}</span>
              </div>
            </div>
            <button
              onClick={logout}
              style={{
                background: "none", border: "1px solid var(--bs-border, #222)", borderRadius: 6,
                padding: "6px 10px", cursor: "pointer",
                fontSize: 9, fontFamily: "JetBrains Mono", color: "var(--bs-muted, #555)",
                letterSpacing: 1,
              }}
            >
              LOG OUT
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", gap: 6 }}>
            <button
              onClick={showAuth}
              style={{
                padding: "7px 14px", borderRadius: 6,
                border: "1px solid var(--bs-border, #333)", background: "none",
                color: "var(--bs-body, #ccc)", cursor: "pointer",
                fontFamily: "JetBrains Mono", fontSize: 10,
                fontWeight: 600, letterSpacing: 1,
              }}
            >
              LOG IN
            </button>
            <button
              onClick={showAuth}
              style={{
                padding: "7px 14px", borderRadius: 6,
                border: "1px solid var(--bs-green-bd, #00e67644)", background: "var(--bs-green-bg, #00e67622)",
                color: "var(--bs-green, #00e676)", cursor: "pointer",
                fontFamily: "JetBrains Mono", fontSize: 10,
                fontWeight: 700, letterSpacing: 1,
              }}
            >
              JOIN
            </button>
          </div>
        )}
        </div>
      </div>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "0 16px", display: "flex" }}>
        {[{ id: "home", label: "Feed" }, { id: "markets", label: "Markets" }, { id: "about", label: "About" }].map(t => (
          <button key={t.id} onClick={() => setPage(t.id)} style={{ padding: "8px 20px", background: "none", border: "none", cursor: "pointer", fontSize: 12, fontWeight: page === t.id ? 700 : 400, color: page === t.id ? "var(--bs-ink, #fff)" : "var(--bs-muted, #666)", borderBottom: page === t.id ? "2px solid var(--bs-green, #00e676)" : "2px solid transparent" }}>{t.label}</button>
        ))}
      </div>
    </header>
  );
}
